const Enum = {
    UpdateStageOperations: "Update Stage Operations",
    P: "Move To Plan - No Inventory Effect, No Charges",
    F: "Move To Future Order - No Effect On Net Available, No Charges",
    N: "Move To Pending - Effects Net Available, No Charges",
    R: "Move To Ready To Receive/Pick/Staged - Effects Available, No Charges",
    C: "Move To Completed/Loaded/Put Away/Transferred/Adjusted - Effects Available, Yes, Charges",
    GeneralOperations: "General Operations",
    Replicate: "Replicate",
    CaptureSignature: "Capture Signature",
    ShowSignature: "Show Signature",
    TransactionSignatures: "Transaction Signatures",
    ShowCustomerCredit: "Show Customer Credit",
    ShowSummaryForm: "Show Customer Summary Status",
    ShowContacts: "Show Contacts",
    ShowInvoices: "Show Invoices",
    ShowShippingInformation : "Show Shipping Information",
    ShowCrateAllocationForm: "Show Crate Allocation Window",
    CommitTransaction: "Commit Current Transaction",
    RecaluclateCharges: "Recalculate Charges",
    GenerateItemTasksRecords: "Generate Item Tasks Records",
    ShowFmTransactionDetail: "Show FM Detail",
    ItemOrTransactionChargesBillTo: "Item/Transaction Charges Bill-To",
    Adjust_Available_Unavailable_Status: "Adjust Available/Unavailable Status",
    CreateRepackShipments: "Create Repack Shipments",
    ShowRepackShipmentRecord: "Show Repack Shipment Record",
    Adjust_Available_Unavailable_Status: "Adjust Available/Unavailable Status",
    CreateTransactionCharges: "Create Transaction Charges",
    ShowTransactionCharges: "Show Transaction Charges",
    ProshipShipment: "Proship Shipment",
    ExportShipmentData: "Export Shipment Data",
    Reports: "Reports",
    PrintReport1: "PrintReport1",
    PrintReport2: "PrintReport2",
    PrintReport3: "PrintReport3",
    PrintReport4: "PrintReport4",
    ApplyCustomLogic : "Apply Custom Logic",
};
const OMOperations = {
    UpdateStageOperations: { name: "Update Stage Operations", isHeader: true },
    StageCanceled: { name: "Canceled - No Inventory Effect", isHeader: false },
    StageQuote: { name: "Quote - No Inventory Effect", isHeader: false },
    StagePlan: { name: "Plan - No Inventory Effect", isHeader: false },
    StageFuture: { name: "Future - No Effect On Net Available", isHeader: false },
    StagePending: { name: "Pending - Effect Net Available", isHeader: false },
    StageAssigned: { name: "Assigned - Effect Available", isHeader: false },
    StagePickedStaged: { name: "Picked/Staged - Effect Available", isHeader: false },
    StageShippedCompleted: { name: "Shipped/Completed - Effect Available", isHeader: false },
    GeneralOperations: { name: "General Operations", isHeader: true },
    ShowCustomerHistory: { name: "Show Customer History", isHeader: false },
    ShowCustomerCredit: { name: "Show Customer Credit",isHeader: false },
    SplitOrder: { name: "Split Order", isHeader: false },
    SplitOrderByTransaction: { name: "Split Order By Transaction", isHeader: false },
    SplitOrderByTransactionAdvanced: { name: "Split Order By Transaction - Advanced", isHeader: false },
    CreateRequisition: { name: "Create PO Requisition", isHeader: false },
    TransferToDispatch: { name: "Transfer Order to FM Dispatch", isHeader: false },
    DisplayProductionStatus: { name: "Display Production Status", isHeader: false },
    SplitDeposit: { name: "Split Deposit", isHeader: false },
    CommitTransaction: { name: "Commit Transaction", isHeader: false },
    ApplyMandatedFees: { name: "Apply Mandated Fees", isHeader: false },
    ApplyCustomFees: { name: "Apply Custom Fees", isHeader: false },
    CalculateCumulativeDiscount: { name: "Calculate Cumulative Discount", isHeader: false },
    CardConnectPay: { name: "Pay with CardConnect", isHeader: false },
    CardConnectVoidRefund: { name: "Refund with CardConnect", isHeader: false },
    GeneratePMProductionUnit: { name: "Generate PM Production Unit", isHeader: false },
    RecalculatePrices: { name: "Recalculate Prices", isHeader: false },
};

const Generic = {
    WebWMCommitTransaction: "WMWEBCOMITINV",
    ABR0003: "ABR0003",
    StandardAbecas: "Standard Abecas",
    FromReadyToCommit: "From Ready to Commit Now Status",
    DelayOption: "250",
}
const OMLocationOperations = {
    GeneralOperations: { name: "General Operations", isHeader: true },
    SortDetailRecords: { name: "Sort Detail Records", isHeader: false, allowWithoutDetailSelection: true },
    SubstituteItems: { name: "Substitute Items", isHeader: false },
    CustomerItemHistory: { name: "Customer Item History", isHeader: false },
    ChangeWarehouse: { name: "Change Warehouse", isHeader: false },
    DisplayLocationHistory: { name: "Display Location History", isHeader: false },
    OpenTransactionForItemLot: { name: "Open OM Transactions for Item/Lot", isHeader: false },
    ResetItemDiscount: { name: "Reset Item Discount", isHeader: false, allowWithoutDetailSelection: true },
    DisplayItemStatus: { name: "Display Item Status", isHeader: false },
    DisplayItemPrices: { name: "Item Prices ", isHeader: false },
    UndoDetails: { name: "Undo Automatic Lot Selection", isHeader: false, allowWithoutDetailSelection: true },
    CommitCommission: { name: "Commit Commission", isHeader: false },
    UpdateRequisitionDetailsForAllItems: { name: "Receive Requisition Details based on all Sales Order Details", isHeader: false, allowWithoutDetailSelection: true },
    UpdateRequisitionDetailsForCurrentItem: { name: "Receive Requisition Details based on the Current Sales Order Detail", isHeader: false },
    CreateProductionManagementRequirements: { name: "Create Production Management Requirements", isHeader: false },
    TransactionDetailGrid: { name: "Transaction Detail Grid", isHeader: false },
    /** Delphi opImportDetailsClick — imports lines for the whole order; does not require a selected detail row. */
    ImportDetails: { name: "Import Details", isHeader: false, allowWithoutDetailSelection: true },
    ShowSerialNumberReceiptEntryForm: { name: "Show Serial Number Receipt Entry Form", isHeader: false },
    ShowSerialNumberShipmentForm: { name: "Show Serial Number Shipment Form", isHeader: false },
    /** Delphi opUpdateSerialNumbers — imports serial numbers for the whole order; does not require a selected detail row. */
    UpdateSerialNumbers: { name: "Update Serial Numbers", isHeader: false, allowWithoutDetailSelection: true },
    DisplayCostComponents: { name: "Display Cost Components", isHeader: false },
    ResetDefaultFreightRatePerItem: { name: "Reset Default Freight Rate Per Item", isHeader: false },
    ReviewedInventoryAllItems: { name: "Reviewed Inventory - All Items", isHeader: false, allowWithoutDetailSelection: true },
};
/**
 * Legacy uOMD0018 / uOMD0040 pmOptions — the Options menu on the Split Order dialog. pmOptions also
 * carries opSort ("Sort Records", uOMD0018.pas:549-575), which sorts the dialog's own detail dataset
 * through a 10-choice radio group — a separate thing from OMLocationOperations.SortDetailRecords on the
 * Sales Order detail grid. It is tracked under DEV-5733 and is not migrated here.
 */
const SplitOrderOperations = {
    SelectSerialNumberRecords: { id: "SelectSerialNumberRecords", name: "Select Serial # Records" },
};
/** Legacy uOMD0013 bottom Options menu on the Item Orders tab (opItemOrderBottomMassPickNote). */
const ItemOrdersGridOptions = {
    MassPickNotesId: "MassPickNotes",
    MassPickNotesDescription: "Mass Pick Notes",
};
/** Legacy uOMD0013 bottom Options menu on the Order Detail tab (opReviewedInventory). */
const OrderDetailGridOptions = {
    ReviewedInventoryId: "ReviewedInventory",
    ReviewedInventoryDescription: "Reviewed Inventory",
};
const PriceLevels = {
    PriceLevelA: "A",
    PriceLevelB: "B",
    PriceLevelC: "C",
    PriceLevelD: "D",
    PriceLevelE: "E",
}
const ReportFilterOperator = {
    StartsWith: 0,
    EndsWith: 1,
    Contains: 2,
    Equal: 3,
    NotEqual: 4,
    Greater: 5,
    GreaterEqual: 6,
    Less: 7,
    LessEqual: 8,
    Between: 9,
    Includes: 10,
}
const ReportFieldTypes ={
        String: 0,
        Integer: 1,
        Decimal: 2,
        Boolean: 3,
        DateTime: 4,
        Flag: 5,
        NotSupported: 6,
        RecordNumber :7
}
// Sublot-grid operations, in the ORDER THEY APPEAR IN THE MENU - object key order drives the
// DropDownButton, because SubLotDetailTabs builds it with Object.entries(). The sequence mirrors
// Delphi's mnuSubLotReceiptsOptions popup (uWMD0002.dfm) exactly, so an operator moving from the
// desktop app finds the options where they expect them. Two Delphi items have no counterpart yet and
// are simply absent: "Enter Transaction Sub Details" (uWMD0089), which would sit after Update Total
// Weights, and "Select All Serial Numbers", which would sit after Create Serial Numbers for Sublot.
// Keep this order in step with Delphi rather than tidying it alphabetically.
//
// Each value is simultaneously the menu caption AND the onItemClick dispatch discriminant.
const WmSubDetailOperations = {
    AutoCreateSubLots: "Auto Create Sublots",
    AutoSelectLocation: "Auto Select Locations",
    AuotCreateSerialNumbers: "Auto Create Serial Numbers",
    UpdateTotalWeight: "Update Total Weights",
    ManuallySelectSublotForShipment: "Manually Select Sublots For Shipment",
    // Port of uWMD0111, whose Delphi caption was "Enter Weights From Scale". Renamed by team decision
    // because the serial-scale half is not implemented, so "From Scale" would name a capability the
    // screen does not have. Position still matches Delphi's.
    EnterWeights: "Enter Weights",
    CreateSerialNumberForSublot: "Create Serial Numbers for Sublot",
    ShowSerialNumber: "Show Serial Numbers",
}
// The Options menu on the Transaction Data Entry details grid. KEY ORDER IS THE MENU ORDER - the
// grid builds its list with Object.entries(), so this block is the single place the sequence is
// decided. It follows mnuTransactionDetailPopup in uWMD0002.dfm item for item, so the web menu reads
// the same as Delphi's; per-entry Visible rules live in DetailsTab's setActionDropDownItems, which is
// why the operator normally sees only a subset.
//
// Two Delphi entries have no web equivalent and are simply absent: opShowCrateWindow ("Show Crate
// Allocation Window", which the web puts on the header Operations menu instead) and opGenerateCrates
// ("Generate Lot/Crates"). Delphi's opDeleteItemCharges is a submenu; the web flattens its two
// children to top level, kept together in the submenu's slot.
const WMTransactionDetailsOptions = {
    AutoSelectLocation: "Auto Select Locations",
    AdjustAvailableUnAvailableStatus: "Adjust Available/Unavailable Status",
    ApplyItemRateSchedule: "Apply Item Rate Schedule",
    ListAvailableLotsLocationsForShipment: "List Available Lots & Locations For Shipment",
    SetSerialNumberVerification: "Set Serial Number Verification",
    SelectByLot: "Select By Lot",
    SelectSublotsByConsignee: "Select Sublots By Consignee",
    ManuallySelectLotsForShipment: "Manually Select Lots For Shipment",
    ManuallySelectLotsAndSublotsForShipment: "Manually Select Lots & Sublots For Shipment",
    ManuallySelectInventoryForShipment: "Manually Select Inventory For Shipment",
    GenerateLotSerialNumbers: "Generate Lot/Serial Numbers",
    DeleteItemChargesForSelectedItem: "Delete Item Charges for Selected Item",
    DeleteItemChargesForAllItems: "Delete Item Charges for All Items",
    ShowDistinctItems: "Show Distinct Items",
    DeleteSerialNumber: "Delete Serial Number",
    CancelLineItems: "Cancel Line Items",
}
// IMITEM.WARRANTYFLAG_SHIPMENT - which expiration date the shipment check uses.
const WarrantyFlagShipment = {
    NotApplicable: "N",
    UseItemExpirationDate: "I",
    UseLotExpirationDate: "L",
    UseSublotExpirationDate: "S",
}
// WMTRANSACTIONDP.LOCATIONBYCLASS - how hard the Reserve Location class rule bites.
const LocationByClass = {
    Off: "N",
    Error: "Y",
    Warn: "W",
}
// IMITEM.CHECKSHIPMENTDAYS - how the shipment expiration check behaves.
const CheckShipmentDays = {
    Off: "1",
    CheckAndAllowOverride: "2",
    CheckAndNeverAllowOverride: "3",
}
const TransactionStage = {
    Completed: "C",
    Future: "F",
    Pending: "N",
    Plan: "P",
    Ready: "R",
    Picked: "S",
    Assigned: "A"
};
const TransactionStatus = {
    Committed: "Z",
    Open: "O",
    Hold: "H",
    ReadyToCommitLater: "L",
    Active: "A"
};
const TransactionTypes = {
    Credit: "C",
    Receipt: "R",
    Shipment: "S",
    Invoice: "I",
    Both: "B",
    Adjustment: "A",
    // WMTRANSACTIONHEADER.TRANSACTIONTYPE = 'M'. The recurring misc-charge screens pin this
    // (uWMM0094.dfm BaseWhere), and WMSTORAGEMISCDP is the profile table behind it. Named for what it
    // means in WM; note the API's Argos.Core.Constants.TransactionType calls the same code "Memo".
    Miscellaneous: "M",
    Lot: "L",
    SubLot: "B",
    FMTripNumber: "F"
};
const DevextremeEnums = {
    AddRowButton: "addRowButton"
}
const Options = {
    Yes: "Y",
    No: "N"
};
const ShipSelection = {
    Yes: "Y",
    No: "N",
    UserDefined: "U"
};
const ItemTypes = {
    Item: "I",
    Lot: "L",
    SubLot: "S"
};
const RecordTypes = {
    Receipt: "R",
    Record: "R",
    Shipment: "S",
    Profile: "P",
};
const TransportationModes = {
   Air :"A", 
   Barge :"B", 
   Ocean :"O", 
   CustomerPickup :"P", 
   Rail :"R", 
   OutsideTruck :"S", 
   CompanyTruck :"T", 
   Container :"C", 
   LTL :"L", 
};
const NextTrans = {
    Item: "I",
    Lot: "L",
    SubLot: "S"
};
// IMITEM.WEIGHTBASISFLAG - which level supplies the net / gross weight per unit shipped.
// Mirrors Argos.Core.Constants.WeightBasis. Delphi branches on it at uWMD0109.pas:499-514
// (the written weights) and :1022-1028 (the running on-screen total).
const WeightBasis = {
    Item: "I",
    Lot: "L",
    Sublot: "S",
    Unit: "U",
    Package: "P",
};
const CrateAllocationGridOptions = {
    GenerateCrateId: "AutoGenerateCrate",
    GenerateCrateDescription: "Generate Crates",
}
const CrateDetailAllocationGridOptions = {
    RemoveCrateId: "RemoveCrateDetailQuantity",
    RemoveCrateDescription: "Remove Crate Detail Quantity",
    ChangeCrateId: "ChangeCrateDetailQuantity",
    ChangeCrateDescription: "Change Crate Detail Quantity",
}
const CrateAllocationLocationGridOptions = {
    AssignToCrateId: "AssignToCrate",
    CrateDescription: "Assign To Crate",
}
const TwoFactorAuthenticationSetting = {
    NotRequired: "N",
    RequiredForAllLogins: "R",
    RequiredForAllInternalLogins: "I",
    RequiredForAllExternalLogins: "E",
    NotRequiredForNextLogin: "NNL",
    NotRequiredFor24Hours: "N24H",
    NotRequiredText: "Not required",
    RequiredForAllLoginsText: "Required for all logins (internal and external)",
    RequiredForAllInternalLoginsText: "Required for all logins (internal only)",
    RequiredForAllExternalLoginsText: "Required for all logins (external only)",
    NotRequiredForNextLoginText: "Not required for next login",
    NotRequiredFor24HoursText: "Not required for 24 hours",
    TwoFASetting: "TwoFASetting",
    TwoFAExpirationDateTime: "TwoFAExpirationDateTime",
    TwoFactorAuthenticationSetting: "TwoFactorAuthenticationSetting"
};
const LocationTypes = {
    DockDoor: "D",
    ForwardPick: "F",
    StagingLocation: "L",
    ProductionLocation: "P",
    StorageLocation: "S",
    Yard: "Y",
};
// WMTRANSACTIONDP.USELOCATION. 'Y' and 'V' both track locations during entry - 'V' additionally
// warns when the target location is not empty (receipts only). Delphi's location gates therefore
// test for both, e.g. uWMD0002.pas:17871.
const UseLocation = Object.freeze({
    Yes: "Y",
    YesWithWarning: "V",
    No: "N",
});
const LocationStatus = Object.freeze({
    AllowAll: "A",
    NotAllowed: "N",
    NotAllowedDuringCommit: "B",
    ReceiptsOnly: "R",
    ShipmentsOnly: "S",
});
const Statuses = {
    Active: "A",
    Inactive: "I",
    History: "Z",
    Open: "O",
    Hold: "H",
    ReadyToCommitLater: "R",
};
// ...existing code...

const ReceivingMethodLot = {
    Sequential: "S",
    Manual: "M",
    Julian: "J"
};

const ShowMasterLot = {
    Sequential: "S",
    None: "N",
    Yes: "Y",
    Full: "F",
    QuickEntry: "M",
};

const ReceivingMethodSubLot = {
    Manual: "M",
    Sequential: "S",
    Unit: "U"
};

const ShowMasterSubLot = {
    None: "N",
    Yes: "Y",
    Auto: "A",
    QuickEntry: "B"
};

const ReceivingMethodUnit = {
    Sequential: "S",
    Manual: "M"
};

const ShowMasterUnit = {
    Yes: "Y",
    None: "N"
};
const YesNo = {
    Yes: "Y",
    No: "N"
};
// WMTRANSACTIONDP.SHIPMENTSONNEG_AVL - which availability figure the shipment negative-inventory
// check measures against when the operator leaves the header (uWMD0002.pas:5316-5336). Any other
// value leaves the check off. Its 'N'/'A' do NOT mean the same as the codes in TransactionStatus or
// TransactionStage, which is why it gets its own enum.
const ShipmentsOnNegativeAvailable = Object.freeze({
    /// Compare against AVAILABLE - opens the WMD0119 grid of offending locations.
    CheckAvailable: "N",
    /// Compare against NET AVAILABLE - message only, no grid.
    CheckNetAvailable: "A"
});

const TransactionStageEnum = Object.freeze({
    Plan: "P",
    FutureOrder: "F",
    Pending: "N",
    ReadyToReceivePickStaged: "R",
    Completed: "C"
});

const TransactionStageDescriptions = Object.freeze({
    Plan: "Plan - No Inventory Effect, No Charges",
    FutureOrder: "Future Order - No Effect On Net Available, No Charges",
    Pending: "Pending - Effects Net Available, No Charges",
    ReadyToReceivePickStaged: "Ready To Receive/Pick/Staged - Effects Available, No Charges",
    Completed: "Completed/Loaded/Put Away/Transferred/Adjusted - Effects Available, Yes, Charges"
});

/** One-word stage labels, for places with no room for the full descriptions above - the Transaction
 *  Data Entry header info bar. Keyed identically to TransactionStageEnum and
 *  TransactionStageDescriptions. Deliberately a separate map, NOT a shortening of those: the full
 *  text carries the inventory-effect clause the Stage dropdowns have to keep. */
const TransactionStageShortLabels = Object.freeze({
    Plan: "Plan",
    FutureOrder: "Future",
    Pending: "Pending",
    ReadyToReceivePickStaged: "Ready",
    Completed: "Completed"
});

const TransactionStatusDescriptions = Object.freeze({
    Open: "Open",
    Hold: "Hold",
    ReadyToCommitLater: "Ready To Commit Later",
    Committed: "Committed"
});
const LokupOptions = {
    Manually: "M",
    NotUsed: "A"
};
const DynamicLookupOptions = Object.freeze({
    GridDisplayMode: "grid",
    SelectBoxDisplayMode: "S"
});

const PriceSource = {
    SinglePrice: "S",
    PriceCode: "P",
    ItemMaster: "I"
};

const PriceMethod = {
    DirectPrice: "D",
    BasisPrice: "B",
    StandardCost: "S",
    AverageCost: "A",
    LastCost: "L"
};

const CalcMethod = {
    PercentMarkup: "M",
    GrossMargin: "G",
    FixedMarkup: "F"
};
const ReportTypes = {
    ArtReport: "A",
    DotnetReport: "T",
    DefaultReport: "R"
};
const ApplyMethod = {
    ApplyMethodSpecifyPrice : "D",
    ApplyMethodDiscountPrice : "Use Discount Price",
    None: "N"
};

const UserDefinedCodeFields = Object.freeze({
    Code1: "USERDEFINEDCODE1",
    Code2: "USERDEFINEDCODE2",
    Code3: "USERDEFINEDCODE3",
    Code4: "USERDEFINEDCODE4",
    Code5: "USERDEFINEDCODE5",
    Code6: "USERDEFINEDCODE6",
    Code7: "USERDEFINEDCODE7",
    Code8: "USERDEFINEDCODE8",
    Code9: "USERDEFINEDCODE9",
    Code10: "USERDEFINEDCODE10"
});
const SourceTypes = {
    DropShip: "D",
    PurchaseOrder:"O",
    Requisition:"V"
}
const InventoryReview ={
    Yes:'Y',
    No:'N',
    Review:'R'
}

const MenuNames = {
    Home: "Home",
    AdvancedReportingTool: "AT - Advanced Reporting Tool",
    DockDoorScheduler: "DD - Dock Door Scheduler",
    ImportExportData: "XM - Import/Export Data",
    SowOrderDatabase: "SO - Sow Order Database",
    PullTagReview: "PU - Pull Tag Review",
    DashboardLite: "DL - Dashboard Lite",
    OrderManagement: "OM - Order Management",
    OrchardManagement: "OR - Orchard Management",
    WarehouseManagement: "WM - Warehouse Management",
    Dashboard: "DB - Dashboard",
    InventoryManagement: "IM - Inventory Management",
    RadioFrequency: "RF - Radio Frequency",
    PurchaseOrderManagement: "PO - Purchase Order Management",
    ElectronicFrequency: "EF - Electronic Frequency",
    AccountingModule: "AC - Accounting Module",
    AccountsPayable: "AP - Accounts Payable",
    AccountsReceivable: "AR - Accounts Receivable",
    CostAccounting: "CA - Cost Accounting",
    ContactManagement: "CM - Contact Management",
    ElectronicDataInterchange: "ED - Electronic Data Interchange",
    FundAccounting: "FA - Fund Accounting",
    FreightManagement: "FM - Freight Management",
    GeneralLedger: "GL - General Ledger",
    HumanResources: "HR - Human Resources",
    Identity: "ID - Identity (Names and Addresses)",
    PartsInventory: "PI - Parts Inventory",
    ProductionManagement: "PM - Production Management",
    Payroll: "PR - Payroll",
    RelationshipManagement: "RM - Relationship Management",
    RateTariffs: "RT - Rate Tariffs",
    SuppliesInventory: "SI - Supplies Inventory",
    ServiceManagement: "SM - Service Management",
    SettlementsProcessing: "SP - Settlements Processing"
};
// OMTRANSACTIONHEADER.CHARGEANDHOLDTYPE codes — Delphi uOMM0000.pas:
// TransIsChargeAndHoldSaleBuyback = 'B', TransIsChargeAndHoldShipment = 'C', default/none = 'A'.
const ChargeAndHoldTypes = {
    None: "A",
    SaleBuyback: "B",
    Shipment: "C",
};
/**
 * Module code -> display name, for every Insight module. Mirrors the C# `PaidForModulesName` and the
 * labels the sidebar renders, so a module reads the same wherever it is shown. Distinct from
 * `MenuNames` above, whose values ("AC - Accounting Module") are sort keys for `GetMenuOrder`, not
 * labels — and which disagrees with the sidebar on EF.
 *
 * Keyed by the codes `Identity/GetModules` returns.
 */
const ModuleNames = Object.freeze({
    AC: "Accounting Module",
    AI: "AI Assistant",
    AP: "Accounts Payable",
    AR: "Accounts Receivable",
    AT: "Advanced Reporting Tool",
    CA: "Cost Accounting",
    CM: "Contact Management",
    DB: "Dashboard",
    DBL: "Dashboard Lite",
    DD: "Dock Door Scheduler",
    ED: "Electronic Data Interchange",
    EF: "Equipment and Facilities Management",
    FA: "Fund Accounting",
    FM: "Freight Management",
    GL: "General Ledger",
    HR: "Human Resources",
    ID: "Identity (Names and Addresses)",
    IM: "Inventory Management",
    OM: "Order Management",
    PI: "Parts Inventory",
    PM: "Production Management",
    PO: "Purchase Order Management",
    PR: "Payroll",
    PTR: "Pull Tag Review",
    RF: "Radio Frequency",
    RM: "Relationship Management",
    RT: "Rate Tariffs",
    SI: "Supplies Inventory",
    SM: "Service Management",
    SO: "Sow Order Database",
    SP: "Settlements Processing",
    Security: "Security",
    TA: "Task Agent",
    TM: "Orchard Management",
    WM: "Warehouse Management",
    XM: "Import/Export Data",
});

const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
/** OM sales-order stage codes (OMTransactionHeader.STAGE). */
const OrderStages = {
    Canceled: "L",
    Quote: "Q",
    Plan: "P",
    Future: "F",
    Pending: "N",
    Assigned: "A",
    PickedStaged: "S",
    ShippedCompleted: "C",
};
/** OMTransactionHeader.FMTRANSFERFLAG codes. */
const FmTransferFlag = {
    None: "N",
    Dispatch: "Y",
    BillingAndDispatch: "A",
};
/** Dispatch profile FM transfer timing (DPFMTRANSFERTIMING). */
const FmTransferTiming = {
    Automatic: "A",
    Batch: "B",
};
/**
 * OMTransactionHeader.CHARGEANDHOLDTYPE codes — the only three values the system stores:
 * 'A' = not charge and hold (default), 'B' = Charge & Hold Sale/Buyback, 'C' = Charge & Hold Shipment.
 * See Form.js opSplitDeposit ("not charge-and-hold shipment" -> 'C') and opTransferToDispatch
 * ("charge-and-hold sale" -> 'B').
 */
const ChargeAndHoldType = {
    NotApplicable: "A",
    Sale: "B",
    Shipment: "C",
};
/** Delphi TransIsChargeAndHold: true for Sale ('B') or Shipment ('C'). Case-insensitive — the column can hold lowercase. */
const isChargeAndHold = (code) => {
    const c = (code || "").trim().toUpperCase();
    return c === ChargeAndHoldType.Sale || c === ChargeAndHoldType.Shipment;
};
/** Delphi TransIsChargeAndHoldShipment: Shipment ('C') only. Case-insensitive. */
const isChargeAndHoldShipment = (code) =>
    (code || "").trim().toUpperCase() === ChargeAndHoldType.Shipment;
/** OM transaction detail line type (DETAILTYPE). */
const DetailTypes = {
    Item: "I",
    NonInventory: "N",
};

// Delphi OMD0018/OMD0040 SplitMode: 0 = "Split Order" (split the current order, no Find
// Transaction), 1 = "Split Order by Transaction" (find the source order first).
const SplitOrderMode = Object.freeze({
    CurrentOrder: 0,
    ByTransaction: 1,
});

/** SPOPENITEMS.BASISTYPE — how a commission Amount is derived from Rate and Basis (OMD0000
 *  edtBasisTypeChange). Mirrors the server-side CommissionBasisType so the two cannot drift. */
const CommissionBasisType = Object.freeze({
    Percentage: "A",
    PerUnit: "U",
    Flat: "F",
});

/** Client-facing text for the Sales Order Detail Commissions grid. */
const CommissionMessages = Object.freeze({
    ParticipantRequired: "Participant is required.",
    Added: "Commission added successfully.",
    Updated: "Commission updated successfully.",
    Deleted: "Commission deleted successfully.",
    DeleteFailed: "Failed to delete commission.",
});
export {
    EMPTY_GUID, OrderStages, FmTransferFlag, FmTransferTiming, ChargeAndHoldType,
    isChargeAndHold, isChargeAndHoldShipment, DetailTypes,
    Enum, TransactionStage, WarrantyFlagShipment, CheckShipmentDays, LocationByClass, WeightBasis, Options, CrateAllocationGridOptions,
    CrateDetailAllocationGridOptions, CrateAllocationLocationGridOptions, TwoFactorAuthenticationSetting, LocationTypes, LocationStatus, UseLocation, ItemTypes, TransactionTypes, ShipSelection, WMTransactionDetailsOptions,
    TransactionStageEnum, TransactionStatus, ShipmentsOnNegativeAvailable, Generic, LokupOptions, PriceLevels, RecordTypes,
    ReceivingMethodLot,
    ShowMasterLot,
    ReceivingMethodSubLot,
    ShowMasterSubLot,
    ReceivingMethodUnit,
    ShowMasterUnit,
    DevextremeEnums,
    ReportFilterOperator,
    DynamicLookupOptions,
    WmSubDetailOperations,
    YesNo,
    Statuses,
    PriceSource,
    PriceMethod,
    CalcMethod,
    ReportFieldTypes,
    ApplyMethod,
    ReportTypes,
    UserDefinedCodeFields,
    TransactionStageDescriptions,
    TransactionStageShortLabels,
    TransactionStatusDescriptions,
    SourceTypes,
    TransportationModes,
    MenuNames,
    ModuleNames,
    OMOperations,
    OMLocationOperations,
    ItemOrdersGridOptions,
    OrderDetailGridOptions,
    InventoryReview,
    SplitOrderMode,
    SplitOrderOperations,
    CommissionBasisType,
    CommissionMessages
};
